import * as yup from 'yup';

const ContactSchema = yup.object().shape({
    email: yup.string()
        .email('Please Enter a valid email')
        .required('Required'),
    name: yup.string()
        .required('Required')
        .max(30),
    message: yup.string()
        .required('Required')
        .min(30)
});

export default ContactSchema;